// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryButton_root__1r4fj","loading":"PrimaryButton_loading__1zdTJ"};